import { translation } from "@@/shared/translations/translation";
import type { Price} from "./price";
import { zeroPrice } from "./price";

const findMinPrice = <T>(
    items: T[],
    iteratee: (item: T) => Price | undefined,
    prefix: boolean,
): Price => {
    const minPrice = items.reduce((agg, item) => {
        const currentPrice = iteratee(item);
        if (!currentPrice) return agg;
        const _min = (price: Price) =>
            price?.amountIncludingVat || Number.MAX_SAFE_INTEGER;
        const aggregatedMinPrice = _min(agg);
        const currentMinPrice = _min(currentPrice);

        if (aggregatedMinPrice >= currentMinPrice) agg = currentPrice;
        return agg;
    }, zeroPrice);

    return (
        minPrice && {
            ...minPrice,
            prefix:
                (prefix &&
                    items.length > 1 &&
                    translation({ sv: "från", en: "from" })) ||
                null,
        }
    );
};

export { findMinPrice };
